import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const ProductSelectionsContainer = styled.div`
  display: grid;
  row-gap: ${primitive.$spacing1};
  padding-bottom: 1.5rem;

  ${Styles.desktop`
    row-gap: 0;
    padding-bottom: 0;
  `}
`;
